export const QUERY_KEYS = {
    GNB_MENU: "gnb-menu",
    HOME_SECTION: "home-section"
};
